export default __webpack_public_path__ + "static/Mexico-City-Cathedral-7a6b40472b8a54ccf1a5f7d433167110.jpg";